import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { ACCOUNTS_URL, REST_API_REQUEST_CALL_URL, Util } from "../utils/index";
import { AlertService } from "../services/index";
import { ApiService } from "../services/api.service";
import { Router } from "@angular/router";

@Injectable()
export class MessageService {
  constructor(
    private http: Http,
    private alertService: AlertService,
    private router: Router,
    private apiService: ApiService
  ) {}

  saveAction(data: any): Observable<any> {
    return this.apiService
      .post(REST_API_REQUEST_CALL_URL.POST_MESSAGE_ACTION_URL, data, true)
      .map((res) => {
        let jsonData = res;
        if (jsonData.result) {
          //결과 데이터 전송
          return res.data;
        } else {
          //에러처리
          if (res.errorCode == "204") {
            // this.authService.logout();

            this.apiService.redirectAccountLogin();
          }
          this.alertService.error(res.errorMsg);
          return null;
        }
      })
      .catch((error: any) => {
        this.alertService.error(
          "서버와 연결이 중단되었습니다.\n" + error.error || "Server error"
        );
        return Observable.throw("Server Error");
      });
  }

  delMsgMaster(messageId: any): Observable<any> {
    return this.apiService
      .post(REST_API_REQUEST_CALL_URL.POST_DELETE_MESSAGE_MASTER + messageId)
      .map((res) => {
        let jsonData = res;
        if (jsonData.result) {
          //결과 데이터 전송
          return res.data;
        } else {
          //에러처리
          if (res.errorCode == "204") {
            // this.authService.logout();

            this.apiService.redirectAccountLogin();
          }
          this.alertService.error(res.errorMsg);
          return null;
        }
      })
      .catch((error: any) => {
        this.alertService.error(
          "서버와 연결이 중단되었습니다.\n" + error.error || "Server error"
        );
        return Observable.throw("Server Error");
      });
  }

  getMessageAcntList(): Observable<Array<MessageAcntModel>> {
    return this.apiService
      .get(REST_API_REQUEST_CALL_URL.GET_MESSAGE_ACTION_URL)
      .map((res) => {
        let jsonData = res;
        if (jsonData.result) {
          //결과 데이터 전송
          return res.data;
        } else {
          //에러처리
          if (res.errorCode == "204") {
            // this.authService.logout();

            this.apiService.redirectAccountLogin();
          }
          this.alertService.error(res.errorMsg);
          return null;
        }
      })
      .catch((error: any) => {
        this.alertService.error(
          "서버와 연결이 중단되었습니다.\n" + error.error || "Server error"
        );
        return Observable.throw("Server Error");
      });
  }

  getMessageList(): Observable<Array<MessageModel>> {
    return this.apiService
      .get(REST_API_REQUEST_CALL_URL.GET_MESSAGE_URL)
      .map((res) => {
        let jsonData = res;
        if (jsonData.result) {
          //결과 데이터 전송
          return res.data;
        } else {
          //에러처리
          if (res.errorCode == "204") {
            // this.authService.logout();

            this.apiService.redirectAccountLogin();
          }
          this.alertService.error(res.errorMsg);
          return null;
        }
      })
      .catch((error: any) => {
        this.alertService.error(
          "서버와 연결이 중단되었습니다.\n" + error.error || "Server error"
        );
        return Observable.throw("Server Error");
      });
  }

  getLgMessageInfoByImprtce(param: any): Observable<LgMessageInfoModel> {
    return this.apiService.get(
      REST_API_REQUEST_CALL_URL.GET_LG_MESSAGES_URL,
      param
    );
  }

  saveMessage(data: any): Observable<any> {
    return this.apiService
      .post(REST_API_REQUEST_CALL_URL.POST_MESSAGE_URL, data, true)
      .map((res) => {
        let jsonData = res;
        if (jsonData.result) {
          //결과 데이터 전송
          return res.data;
        } else {
          //에러처리
          if (res.errorCode == "204") {
            // this.authService.logout();

            this.apiService.redirectAccountLogin();
          }
          this.alertService.error(res.errorMsg);
          return null;
        }
      })
      .catch((error: any) => {
        this.alertService.error(
          "서버와 연결이 중단되었습니다.\n" + error.error || "Server error"
        );
        return Observable.throw("Server Error");
      });
  }

  getConsultMessageInfo(reqNo: String) {
    return this.apiService.get(
      REST_API_REQUEST_CALL_URL.GET_CONSULT_LG_MESSAGES_URL + reqNo
    );
  }

  updateLgMsgStusCd(lgMessageModel: LgMessageModel): Observable<any> {
    return this.apiService
      .post(
        REST_API_REQUEST_CALL_URL.POST_UPDATE_LG_MESSAGES_STATUS_URL,
        lgMessageModel,
        true
      )
      .map((res) => {
        let jsonData = res;
        if (jsonData.result) {
          return jsonData.data;
        } else {
          //에러처리
          if (res.errorCode == "204") {
            // this.authService.logout();

            this.apiService.redirectAccountLogin();
          }
          this.alertService.error(res.errorMsg);
          return null;
        }
      })
      .catch((error: any) => {
        this.alertService.error(
          "서버와 연결이 중단되었습니다.\n" + error.error || "Server error"
        );
        return Observable.throw("Server Error");
      });
  }
}

export class MessageAcntModel {
  public actnId: number;
  public actnCnt: string;
  public actnTp: string;
}

export class MessageModel {
  public messageId: number;
  public actnId: number;
  public dstrActnId: number;
  public uperMessageId: number;
  public messageCnt: string;
  public subMessageCnt: string;
  public recvTp: string;
  public insUserId: number;
  public insDtm: string;
  public uptUserId: number;
  public uptDtm: string;
  public fixYn: number;
  public isImportance: number;
  public isWarning: number;
  public messageKind: string;
}

export class LgMessageModel {
  public messageLogId: number;
  public messageId: number;
  public messageRecvDtm: Date;
  public recvUserId: number;
  public stusCd: number;
  public reqNo: string;
  public quotNo: string;
  public message: MessageModel;
  public prtLgMsg: LgMessageModel;
  public existChild: boolean;
  public mapValue: string;
}

export class LatestInfoModel {
  public newMsgLogCnt: number;
  public lastLgMsgDate: string;
}

export class LgMessageInfoModel {
  public lgMessagePage: LgMessagePageModel;
  public latestInfo: LatestInfoModel;
}

export class LgMessagePageModel {
  public dataLst: Array<LgMessageModel>;
  public pageNo: number;
  public size: number;
  public totalElems: number;
  public totalPages: number;
}



// WEBPACK FOOTER //
// ./src/app/services/message.service.ts